<template>
    <div class="cell-info">
        <img
            :class="cellIconClasses"
            :src="cellIcon"
            :width="iconWidth"
            :height="iconHeight"
            :style="iconClass"
        />
        <span class="cell-type">{{ cellLabelText }}</span>
        <span class="cell-title"> {{ cellTitle }} </span>
    </div>
</template>

<script>
import { getIconPathByCellType } from '../../utils/cell/automation-display-utils';

export const CELL_LABEL = {
    PREFIX: 'funnel.edit.sideBar.',
};
export const CELL_ICON = {
    PREFIX: '/resources/funnel/images/svg/',
    SUFFIX: '_white.svg',
};
export const NOTE_TYPE = {
    METADATA: 'notes',
    ICON: 'notes_white.svg',
    LABEL: 'Notes',
};
export default {
    CELL_ICON,
    CELL_LABEL,
    NOTE_TYPE,
    props: {
        itemType: {
            type: String,
            required: true,
        },
        cellType: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        cellLabel: {
            type: String,
            default: null,
        },
        iconSrc: {
            type: String,
            default: undefined,
        },
        iconWidth: {
            type: String,
            default: '32',
        },
        iconHeight: {
            type: String,
            default: '32',
        },
        iconClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        cellIcon() {
            return getIconPathByCellType(this.cellType);
        },

        cellLabelText() {
            const path = `${CELL_LABEL.PREFIX}${this.itemType}.${this.cellType}`;

            let result = this.$t(path);

            if (this.cellType === NOTE_TYPE.METADATA) {
                result = NOTE_TYPE.LABEL;
            }

            return this.cellLabel ?? result;
        },

        cellTitle() {
            return this.title?.replaceAll('~br~', ' ') || '';
        },

        cellIconClasses() {
            return `cell-type-icon ${this.iconClass}`;
        },
    },
};
</script>
<style lang="scss" scoped>
.cell-info {
    margin-left: $spacing-150;
    display: grid;
    grid-template-areas: 'celltypeicon celltype' 'celltypeicon celltitle';
    grid-template-columns: 10% 90%;
    grid-template-rows: px-to-rem(32) px-to-rem(16);
    align-items: end;
}
.cell-type-icon {
    grid-area: celltypeicon;
    margin-bottom: $spacing-075;
}
.cell-type {
    grid-area: celltype;
    font-weight: 400;
    font-size: px-to-rem(16);
    line-height: px-to-rem(24);
    color: $color-ink-900;
}
.cell-title {
    grid-area: celltitle;
    font-weight: 400;
    font-size: px-to-rem(12);
    line-height: px-to-rem(16);
    color: $color-ink-800;
}
.decision-icon-class {
    margin-left: $spacing-200;
    margin-bottom: $spacing-200;
}
</style>
